import { joinURL } from 'ufo';
import { useAppConfig } from '#app/config';
import { useRuntimeConfig } from '#app/nuxt';

export function useProjectApiBaseUrl(): string {
	const runtimeConfig = useRuntimeConfig();
	const appConfig = useAppConfig();

	if (!appConfig.monospace.projectSlug) throw new Error('No project selected');

	return joinURL(runtimeConfig.public.api, appConfig.monospace.projectSlug);
}
